import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { FormContext } from '../../shared/contexts/form-context';
import { WatermarkWrapper } from './form-preview.styled';
import { toHex } from '../../../shared/form-lib';

const createdWithFormPlus = () => (
  <>
    Created with <span style={{ color: '#800' }}>&#10084;</span> on
    <a href="/e/features?utm_source=formplus_form&utm_medium=link" id="formplus_link">
      <strong> Formplus </strong>
    </a>
  </>
);

const reportAbuseLink = () => (
  <a href="https://help.formpl.us/s/contactsupport" target="_blank" rel="noreferrer noopener" id="report_abuse_link">
    <em> Report Abuse </em>
  </a>
);

const FormWatermark = ({ formDesign, useInvisibleRecaptcha }) => {
  const { PLAN, inForm } = useContext(FormContext);
  const { is_trial, is_platinum, is_unlimited, is_enterprise } = PLAN || {};

  const fontStyles = {
    '--font-family': formDesign?.old?.form_font,
    '--form-text-color': toHex(formDesign?.old?.form_text_color),
  };

  return (
    <>
      {!(is_unlimited || is_platinum || is_enterprise) && !is_trial && (
        <WatermarkWrapper style={fontStyles}>
          <p>
            {createdWithFormPlus()} | {reportAbuseLink()}
          </p>
        </WatermarkWrapper>
      )}

      {is_trial && (
        <WatermarkWrapper style={fontStyles}>
          <p>{createdWithFormPlus()}</p>
          <p> Do not submit passwords and sensitive information on this form | {reportAbuseLink()}</p>
        </WatermarkWrapper>
      )}
      
      {(useInvisibleRecaptcha && inForm) && (
        <WatermarkWrapper
          style={{
            justifyContent: 'center',
            flexDirection: 'row',
            display: 'flex',
            ...fontStyles,
            gap: 8
          }}>
          <img
            src="https://storage.googleapis.com/fplsblog/recaptcha-icon.svg"
            style={{ margin: 0 }}
            alt="recaptcha_icon"
            height="24"
            width="24"
          />
          
          This site is protected by Google reCaptcha
        </WatermarkWrapper>
      )}
    </>
  );
};

FormWatermark.defaultProps = {
  formDesign: {},
};

FormWatermark.propTypes = {
  useInvisibleRecaptcha: PropTypes.bool.isRequired,
  formDesign: PropTypes.shape({
    old: PropTypes.shape({
      form_font: PropTypes.string.isRequired,
      form_text_color: PropTypes.string.isRequired,
    }).isRequired,
  }),
};

export default FormWatermark;
